const replaceAffiliations = {
  type: 'Matrix',
  key: 'replaceAffiliations',
  value: 'No'
};

export default replaceAffiliations;



// WEBPACK FOOTER //
// ./app/models/replaceAffiliationsIntegration.js